import { useState, useEffect } from 'react';
import { User } from '../types/auth';

// Hook personalizado para acessar dados do usuário em qualquer lugar
export const useUserData = () => {
  const [userData, setUserData] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Função para carregar dados do localStorage
  const loadUserData = (): User | null => {
    try {
      const data = localStorage.getItem('@ReactorFinances:userData');
      if (data) {
        const parsedData = JSON.parse(data);
        return parsedData;
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  // Função para salvar dados no localStorage
  const saveUserData = (data: User) => {
    try {
      localStorage.setItem('@ReactorFinances:userData', JSON.stringify(data));
      setUserData(data);
    } catch (error) {
      // Erro silencioso
    }
  };

  // Função para limpar dados
  const clearUserData = () => {
    try {
      localStorage.removeItem('@ReactorFinances:userData');
      setUserData(null);
    } catch (error) {
      // Erro silencioso
    }
  };

  // Carrega dados na inicialização
  useEffect(() => {
    const data = loadUserData();
    setUserData(data);
    setIsLoading(false);
  }, []);

  // Escuta mudanças no localStorage (para sincronizar entre abas)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === '@ReactorFinances:userData') {
        if (e.newValue) {
          try {
            const newData = JSON.parse(e.newValue);
            setUserData(newData);
          } catch (error) {
            // Erro silencioso
          }
        } else {
          setUserData(null);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    userData,
    isLoading,
    saveUserData,
    clearUserData,
    refreshUserData: () => {
      const data = loadUserData();
      setUserData(data);
      return data;
    }
  };
};